import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("/API/UnitOwner/AddUnitOwnr", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("API/Customer/GetAllUsers")
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_OwnersManagements", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  SearchUnitOwner({ commit }, search) {
  debugger;
    return new Promise((resolve, reject) => {
      axios
        .post("API/UnitOwner/SearchUnitOwner",search)
        .then(response => {
          resolve(response);
          commit("SET_OwnersManagements", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateItem(context, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .post("API/UnitOwner/UpdateUnitOwner", item)
        .then(response => {
          resolve(response);
         // commit("UPDATE_UnitOwner", item);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetItemByID({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios
      .get("API/UnitOwner/GetUnitOwnerById?Id=" + itemid)
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_OwnersManagements", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GetUnitPayments(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/UnitOwner/GetUnitPayments?Id=" + itemid)
        .then(response => {
          debugger;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },


  GetUnitOwnersNotApproved() {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/UnitOwner/GetNewOwnersCount")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetOwnersNotApproved() {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/UnitOwner/GetUnitOwnersNotApproved")
        .then(response => {
          debugger;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  DeleteUnitOwner({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .delete("API/UnitOwner/DeleteUnitOwnr?Id=" + item.id)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.ID);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UploadImage(context, image) {
    const formData = new FormData();
    formData.append("file",image, image.name);
    return new Promise((resolve, reject) => {
      axios
        .post("/API/Common/UploadFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  BlockOrUnBlockUser(context, Id) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/UnitOwner/BlockOrUnBlockUser?Id="+Id)
        .then(response => {
          debugger;
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UnBlockUser(context, Id) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/UnitOwner/UnBlockUnitOwner?Id="+Id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  Paid(context, Id) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/UnitOwner/PaidOwnerPayment?Id="+Id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  ApproveOrDenayUnitOwner(context, Id) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/Authentication/AcceptRegistrationRequests?Id="+Id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  CancelRequest({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .delete("API/UnitOwner/DeleteUnitOwnr?Id=" + item)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.ID);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
